import { createSelector } from 'reselect';
import { getTicketAllocations } from '.';
import isEmpty from 'lodash/isEmpty';

/**
 * Returns an object with paxIds as keys and their first ticket allocation ids as values
 */
const getFirstTicketsForPax = createSelector(
  (state, bookingReference) => getTicketAllocations(state, bookingReference),
  ticketAllocations => {
    if (isEmpty(ticketAllocations)) {
      return {};
    }

    // Group tickets by paxId and keep the first one for each pax
    return ticketAllocations.reduce((currentTickets, ticket) => {
      const { paxId } = ticket;
      if (paxId && !currentTickets[paxId]) {
        currentTickets[paxId] = ticket.id;
      }
      return currentTickets;
    }, {});
  },
);

export default getFirstTicketsForPax;
